export default __webpack_public_path__ + "static/media/search-icon-blue.b0c22091.svg";